import { createAsyncThunk } from '@reduxjs/toolkit';
import { Hexabase } from 'hexabase-sdk';
import { registerService } from '../../../services';

export const getMedicalInstitution = createAsyncThunk<any, string | undefined>(
  'medicalInstitution/getListItems',
  async (valueSearch) => {
    try {
      let t_medical_institution = await Hexabase.items().getItemsAsync({
        project_id: 'CPAP',
        datastore_id: 't_medical_institution',
        per_page: 20,
        page: 1,
        use_display_id: true,
        sort_field_id: 'created_at',
        sort_order: 'desc',
        conditions: !valueSearch
          ? undefined
          : [
              {
                search_value: [valueSearch],
                data_type: 'text',
                id: 'facility_name',
                exact_match: false,
                include_null: false,
              },
            ],
      });
      return t_medical_institution;
    } catch (e) {
      console.log(e);
    }
  },
);

export const getDataStoreFields = createAsyncThunk<any, { appId: string; dataStoreId: string }>(
  'register/getDataStoreFields',
  async (params) => {
    const response = await registerService.getDataStoreFields(params);
    return response;
  },
);
